import config from "../config";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { prepareHeaders } from "./utils";
import type { AccountStatusGetResponse } from "../../../api/src/users/attorney/law-firms/route";

export const stripeAccountApi = createApi({
  reducerPath: "stripeAccountApi",
  baseQuery: fetchBaseQuery({
    baseUrl: config.api,
    prepareHeaders,
  }),
  tagTypes: ["StripeAccountStatus"],
  endpoints: (builder) => ({
    getStripeAccountStatus: builder.query<
      AccountStatusGetResponse,
      {
        userId: string;
        attorneyId: string;
        lawFirmId: string;
      }
    >({
      query: ({ userId, attorneyId, lawFirmId }) => ({
        url: `users/${userId}/attorneys/${attorneyId}/law-firms/${lawFirmId}/account-status`,
        method: "GET",
      }),
      providesTags: (result, _error, { lawFirmId }) =>
        result ? [{ type: "StripeAccountStatus", id: lawFirmId }] : [],
    }),
  }),
});

export const { useGetStripeAccountStatusQuery } = stripeAccountApi;
